const {createElement, appendTo, toggleClass, parent, removeClass} = require("nevermorejs/lib/dom");
const {repeaterWith} = require("nevermorejs/lib/item");
const {toSameWeek} = require("helpers/moment");

/* class
 -------------------------------------------------- */

class ItemActions {

	constructor(container) {
		container.on("itemMount", item => {
			this.createItemDom(container, item);
			this.bindIemEvents(container, item);
			this.updateItem(container, item);
		});

		container.on("itemChange", item => {
			this.updateItem(container, item);
		});

		container.on("itemAdd", item => {
			this.updateItem(container, item);
		});
	}

	createItemDom(container, item) {
		// menu wrapper
		const menu = appendTo(
			item.dom.querySelector(".nvm-item-controls"),
			createElement(
				`<div class="nvm-item-menu">
					<button type="button" class="nvm-item-menu-toggle">
						<span></span>
						<span></span>
						<span></span>
					</button>
					<div class="nvm-item-menu-body"></div>
				</div>`
			)
		);

		// items
		const items = appendTo(
			menu.querySelector(".nvm-item-menu-body"),
			createElement(`<div class="nvm-item-menu-body-option"></div>`)
		);

		// text
		const text = appendTo(
			menu.querySelector(".nvm-item-menu-body-option"),
			createElement(`<span>Handlinger</span>`)
		);

		// Edit
		appendTo(
			items,
			createElement(
				`<button type="button" class="nvm-item-edit">Rediger</button>`
			)
		);

		// Add repeater exception
		appendTo(
			items,
			createElement(
				`<button type="button" class="nvm-item-repeater-add-exception">Fjern</button>`
			)
		);

		// remove
		appendTo(
			items,
			createElement(
				`<button type="button" class="nvm-item-remove">Fjern</button>`
			)
		);
	}

	bindIemEvents(container, item) {
		const menu = item.dom.querySelector(".nvm-item-menu");
		const items = menu.querySelector(".nvm-item-menu-body");

		// toggle
		menu.querySelector(".nvm-item-menu-toggle").addEventListener("click", e => {
			e.preventDefault();
			e.stopPropagation();

			toggleClass(menu, "nvm-menu-active");
		});

		window.addEventListener("click", e => {
			if ((e.target === items) || (parent(e.target, ".nvm-item-menu-body"))) {
				return;
			}

			removeClass(menu, "nvm-menu-active");
		});

		// edit
		menu.querySelector(".nvm-item-edit").addEventListener("click", e => {
			e.preventDefault();
			e.stopPropagation();

			container.emit("itemEdit", item);
		});

		// add repeater exception
		menu.querySelector(".nvm-item-repeater-add-exception").addEventListener("click", e => {
			e.preventDefault();
			e.stopPropagation();

			container.updateItem(item, {
				repeater: repeaterWith(
					item.repeater,
					item.weekFrom(container.getDate())
				)
			}, {origin: "repeater-add-exception"})
		});

		// remove
		menu.querySelector(".nvm-item-remove").addEventListener("click", e => {
			e.preventDefault();
			e.stopPropagation();

			container.removeItem(item);
		});
	}

	updateItem(container, item) {
		const menu = item.dom.querySelector(".nvm-item-menu");
		menu.querySelector(".nvm-item-repeater-add-exception").disabled = !item.repeats;
		menu.querySelector(".nvm-item-remove").innerText = item.repeats ? "Fjern alle" : "Fjern";
	}

}

module.exports = ItemActions;



// WEBPACK FOOTER //
// ./resources/js/components/backend/calendar/plugins/ItemActions.js